import { useRef } from 'react';

export function useStateRef<T>(state: T) {
  const ref = useRef(state);
  ref.current = state;
  return ref;
}
